/** @format */

import { useContext } from 'react';
import { MenuContext } from 'providers';

function useMenu() {
  return useContext(MenuContext);
}

export { useMenu };
